module.exports = __webpack_public_path__ + "e70d478b3b3064139c43c5c162e5d7a9.svg";